/// Angular modules ///
import { BrowserModule } from "@angular/platform-browser";
import {
  NgModule,
  APP_INITIALIZER,
  LOCALE_ID,
  NO_ERRORS_SCHEMA,
} from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { TranslateModule, TranslateLoader, TranslateService } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { UrlSerializer } from "@angular/router";

/// ngrx modules ///
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";

/// External libs ///
import { NouisliderModule } from "ng2-nouislider";

/// Routing ///
import { routing, appRoutingProviders } from "./app.routing";

/// Application modules ///
import { AppComponent } from "./app.component";
import { ProductModule } from "./products/product.module";
import { ProductService } from "./products/product.service";
import { LayoutService } from "./shared/service/layout.service";
import { ScriptService } from "./shared/service/script.service";
import { SeoService } from "./shared/service/seo.service";
import { CartService } from "./shared/service/cart.service";
import { ProductEffects } from "./products/product.effects";
import { reducers } from "./reducers";
import { ViewportDetector } from "./shared/viewport-detector";
import { TopnavComponent } from "./shared/layout/topnav/topnav.component";
import { BackToTopComponent } from "./back-to-top/back-to-top.component";
import { RedirectComponent } from "./redirect/redirect.component";
import { TrailingSlashUrlSerializer } from "./custome-url-serializer";
import { SafeHtmlPipe } from "./shared/pipes/safe-html.pipe";
import { ThemeModule } from "@kui-angular/theme";
import { ButtonModule } from "@kui-angular/button";
export const metaReducers = [];
var assetslocation = {
  // add your local environment in this array to test on local network devices
  "http://localhost:4200": "http://localhost:4200",
  "https://stg-shop.nvidia.partners": "https://stg-shop.nvidia.partners",
  "https://shop.nvidia.partners": "https://stg-shop.nvidia.partners",
  "https://shop.nvidia.com": "https://shop.nvidia.com",
  "https://dev-shop.nvidia.com": "https://dev-shop.nvidia.com",
  "https://stg-shop.nvidia.com": "https://stg-shop.nvidia.com",
  "https://preview.nvidia.com": "https://stg-shop.nvidia.com",
  "https://store.nvidia.com": "https://store.nvidia.com",
  "https://dev-store.nvidia.com": "https://dev-store.nvidia.com",
  "https://stg-store.nvidia.com": "https://stg-store.nvidia.com",
};
declare module "@angular/core" {
  interface ModuleWithProviders<T = any> {
    ngModule: Type<T>;
    providers?: (Provider | EnvironmentProviders)[];
  }
}

@NgModule({
  declarations: [
    AppComponent,
    TopnavComponent,
    BackToTopComponent,
    RedirectComponent,
    SafeHtmlPipe,
  ],
  imports: [
    ThemeModule,
    ButtonModule,
    BrowserModule,
    HttpClientModule,
    StoreModule.forRoot(reducers, { metaReducers }),
    routing,
    NouisliderModule,
    FormsModule,
    ReactiveFormsModule,
    EffectsModule.forRoot([ProductEffects]),
    StoreDevtoolsModule.instrument({ maxAge: 25 }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ProductModule,
  ],
  providers: [
    appRoutingProviders,
    ViewportDetector,
    ProductService,
    LayoutService,
    ScriptService,
    SeoService,
    CartService,
    { provide: UrlSerializer, useClass: TrailingSlashUrlSerializer },
    { provide: LOCALE_ID, useValue: "fr" },
    {
      provide: APP_INITIALIZER,
      useFactory: initTranslation,
      deps: [TranslateService],
      multi: true,
    },
  ],
  schemas: [NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(
    http,
    window.location.origin == "http://localhost:4200"
      ? "../assets/i18n/"
      : "/studio/store/assets/i18n/",
    ".json"
  );
}

export function initTranslation(translate: TranslateService) {
  return () => {
    translate.setDefaultLang("en-us");
    translate.use("en-us");
    return Promise.resolve();
  };
}

export function load1(script: ScriptService) {
  return () => {
    return script.load1();
  };
}
